import triggerIds from './line-and-paragraph-spacing-trigger-ids';

const lineHeightMap = {
  [triggerIds.LINE_HEIGHT_1]: '1.0',
  [triggerIds.LINE_HEIGHT_1_1]: '1.1',
  [triggerIds.LINE_HEIGHT_1_2]: '1.2',
  [triggerIds.LINE_HEIGHT_1_3]: '1.3',
  [triggerIds.LINE_HEIGHT_1_5]: '1.5',
  [triggerIds.LINE_HEIGHT_1_6]: '1.6',
  [triggerIds.LINE_HEIGHT_1_7]: '1.7',
};

export default lineHeightMap;
